/* Bannière de cookies Whoosh, branchée sur l'API de consentement de Shopify.
   - S'affiche tant que le visiteur n'a pas fait de choix (France, Belgique, Suisse :
     le consentement est requis), uniquement sur l'accueil et une seule fois.
   - « Tout accepter » / « Tout refuser » / choix détaillés -> Shopify.customerPrivacy.setTrackingConsent.
   - Tout lien vers #cookies (pied de page « Gérer mes cookies ») rouvre l'écran des choix. */
(function () {
  var CATEGORIES = ["preferences", "analytics", "marketing"];

  function api(cb) {
    var S = window.Shopify;
    if (S && S.customerPrivacy) return cb(S.customerPrivacy);
    if (S && typeof S.loadFeatures === "function") {
      S.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (err) {
        cb(err ? null : window.Shopify.customerPrivacy);
      });
    } else {
      cb(null);
    }
  }

  function consentementActuel(cp) {
    try {
      return (cp && cp.currentVisitorConsent && cp.currentVisitorConsent()) || {};
    } catch (e) {
      return {};
    }
  }

  /* Microsoft Clarity (enregistrements de visites, cartes de chaleur) : chargé seulement
     après l'accord « mesure d'audience » de la visiteuse (21/10). L'intégration
     automatique de l'application est désactivée dans l'éditeur, car elle envoyait des
     données avant tout choix et même après un refus. */
  var CLARITY_ID = "z16h32th2i";
  var clarityCharge = false;

  function chargerClarity(marketing) {
    if (!clarityCharge) {
      clarityCharge = true;
      window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
      var t = document.createElement("script");
      t.async = true;
      t.src = "https://www.clarity.ms/tag/" + CLARITY_ID;
      document.head.appendChild(t);
    }
    window.clarity("consentv2", { ad_Storage: marketing ? "granted" : "denied", analytics_Storage: "granted" });
  }

  function appliquerClarity(cp) {
    var c = consentementActuel(cp);
    if (c.analytics === "yes") chargerClarity(c.marketing === "yes");
    else if (clarityCharge && window.clarity) window.clarity("consent", false);
  }

  var CLE_VUE = "wh-cookies-vue";
  function dejaVue() {
    try { return window.localStorage.getItem(CLE_VUE) === "1"; } catch (e) { return false; }
  }
  function marquerVue() {
    try { window.localStorage.setItem(CLE_VUE, "1"); } catch (e) {}
  }

  function dejaChoisi(cp) {
    var c = consentementActuel(cp);
    return CATEGORIES.some(function (k) { return c[k] === "yes" || c[k] === "no"; });
  }

  function init(racine) {
    if (racine.__wck) return;
    racine.__wck = true;
    var vues = racine.querySelectorAll("[data-vue]");
    var cases = racine.querySelectorAll("[data-wck-cat]");

    function montrer(nom) {
      vues.forEach(function (v) { v.hidden = v.getAttribute("data-vue") !== nom; });
    }

    function ouvrir(nom) {
      montrer(nom || "accueil");
      racine.hidden = false;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { racine.classList.add("is-ouvert"); });
      });
    }

    function fermer() {
      racine.classList.remove("is-ouvert");
      setTimeout(function () { racine.hidden = true; }, 450);
    }

    function remplirCases(cp) {
      var c = consentementActuel(cp);
      cases.forEach(function (input) {
        input.checked = c[input.getAttribute("data-wck-cat")] === "yes";
      });
    }

    function enregistrer(choix) {
      api(function (cp) {
        if (!cp || !cp.setTrackingConsent) return fermer();
        cp.setTrackingConsent(
          {
            preferences: !!choix.preferences,
            analytics: !!choix.analytics,
            marketing: !!choix.marketing,
            sale_of_data: !!choix.marketing
          },
          function () {
            if (choix.analytics) chargerClarity(!!choix.marketing);
            else if (clarityCharge && window.clarity) window.clarity("consent", false);
            fermer();
          }
        );
      });
    }

    racine.addEventListener("click", function (e) {
      var b = e.target.closest("[data-wck]");
      if (!b) return;
      var action = b.getAttribute("data-wck");
      if (action === "tout") enregistrer({ preferences: true, analytics: true, marketing: true });
      else if (action === "rien") enregistrer({});
      else if (action === "choix") api(function (cp) { remplirCases(cp); montrer("choix"); });
      else if (action === "enregistrer") {
        var choix = {};
        cases.forEach(function (input) { choix[input.getAttribute("data-wck-cat")] = input.checked; });
        enregistrer(choix);
      }
    });

    document.addEventListener("click", function (e) {
      var lien = e.target.closest('a[href="#cookies"]');
      if (!lien) return;
      e.preventDefault();
      api(function (cp) { remplirCases(cp); ouvrir("choix"); });
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !racine.hidden && racine.querySelector('[data-vue="choix"]:not([hidden])')) {
        montrer("accueil");
      }
    });

    racine.__ouvrir = ouvrir;
    racine.__fermer = fermer;

    if (racine.getAttribute("data-mode-editeur") === "1") return;
    api(function (cp) {
      appliquerClarity(cp);
      if (dejaChoisi(cp)) return;
      /* Ouverture automatique seulement sur la page d'accueil, et une seule fois par
         navigateur (demande de Raph, 01/11). Sans choix, le suivi reste coupé ;
         « Gérer mes cookies » (pied de page) rouvre la bannière sur toutes les pages. */
      if (racine.getAttribute("data-accueil") !== "1" || dejaVue()) return;
      marquerVue();
      ouvrir("accueil");
    });
  }

  function demarrer() {
    document.querySelectorAll("[data-wh-cookies]").forEach(init);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", demarrer);
  else demarrer();

  /* Éditeur de thème : la bannière s'affiche quand la section est sélectionnée. */
  document.addEventListener("shopify:section:load", demarrer);
  document.addEventListener("shopify:section:select", function (e) {
    var r = e.target.querySelector("[data-wh-cookies]");
    if (r) { init(r); r.__ouvrir("accueil"); }
  });
  document.addEventListener("shopify:section:deselect", function (e) {
    var r = e.target.querySelector("[data-wh-cookies]");
    if (r && r.__fermer) r.__fermer();
  });
})();
